import { render, staticRenderFns } from "./ShowResearch.vue?vue&type=template&id=06781f40&"
import script from "./ShowResearch.vue?vue&type=script&lang=js&"
export * from "./ShowResearch.vue?vue&type=script&lang=js&"
import style0 from "./ShowResearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports